export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.resendIfActive = true;
		console.log(this);
    }

    send() {
        this.Alert('info', 'company.user-directories.manage-group.accounts.verify.re-sending-verifications');


        this.isSaving = true;
        this.AccountsResource
            .resendVerificationEmailForGroup(this.companyId, this.group.id, this.resendIfActive)
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.accounts.verify.re-sending-verifications-success'))
            .catch(() => this.Alert('danger', 'company.user-directories.manage-group.accounts.verify.re-sending-verifications-error'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/verify/send-verification-emails.controller.js